// extracted by mini-css-extract-plugin
export var statItem = "_kz-1";
export var statsRow = "_kz-0";